import React from 'react';
import "./DemoInstructions.css"

const DemoInstructions = () => {
  return (
    <div className="demo-instructions">
      <h2>Welcome to the NexGen Sites Demo!</h2>
      <p>Here are some instructions to get you started:</p>
      <ol>
        <li>Click on the canvas to add new elements</li>
        <li>Drag and drop elements to rearrange them</li>
        <li>Use the toolbar to customize element properties</li>
        <li>Create new pages using the "+" button in the page manager</li>
        <li>Enjoy building your web project!</li>
      </ol>
      <p>Feel free to experiment and create your own designs. Happy building!</p>
    </div>
  );
};

export default DemoInstructions;